import { jsxs, jsx } from "react/jsx-runtime";
const KIND_ACCENT = {
  cancel: { icon: "🚫", accentColor: "#DC2626", accentBg: "#FEF2F2" },
  refund: { icon: "💰", accentColor: "#D97706", accentBg: "#FFFBEB" },
  return: { icon: "↩️", accentColor: "#7C3AED", accentBg: "#F5F3FF" }
};
const ConfirmWidget = ({ data }) => {
  const { kind, title, body, primaryLabel, secondaryLabel, lineItems, totalAmount } = data;
  const { icon, accentColor, accentBg } = KIND_ACCENT[kind] ?? KIND_ACCENT.cancel;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: 420,
        background: "var(--voice-widget-card-bg, #FFFFFF)",
        border: `1.5px solid ${accentColor}33`,
        borderRadius: 16,
        padding: "18px 18px 16px",
        boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.07)"
      },
      children: [
        /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 10 }, children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                width: 34,
                height: 34,
                borderRadius: "50%",
                background: accentBg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 16,
                flexShrink: 0
              },
              children: icon
            }
          ),
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  fontSize: 14,
                  fontWeight: 700,
                  color: "var(--voice-widget-fg, #111827)",
                  lineHeight: 1.3
                },
                children: title
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  fontSize: 12,
                  color: "var(--voice-widget-muted, #6B7280)",
                  marginTop: 3,
                  lineHeight: 1.4
                },
                children: body
              }
            )
          ] })
        ] }),
        lineItems && lineItems.length > 0 && /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              background: "var(--voice-widget-img-bg, #F9FAFB)",
              borderRadius: 8,
              padding: "8px 12px",
              marginBottom: 12
            },
            children: [
              lineItems.map((li, i) => /* @__PURE__ */ jsxs(
                "div",
                {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: 12,
                    padding: "3px 0",
                    borderBottom: i < lineItems.length - 1 ? "1px solid var(--voice-widget-border, #E5E7EB)" : void 0
                  },
                  children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "var(--voice-widget-muted, #6B7280)" }, children: li.label }),
                    /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "var(--voice-widget-fg, #111827)" }, children: li.value })
                  ]
                },
                i
              )),
              totalAmount && /* @__PURE__ */ jsxs(
                "div",
                {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: 13,
                    fontWeight: 700,
                    paddingTop: 6,
                    marginTop: lineItems.length > 0 ? 4 : 0,
                    borderTop: lineItems.length > 0 ? `1px solid ${accentColor}33` : void 0,
                    color: accentColor
                  },
                  children: [
                    /* @__PURE__ */ jsx("span", { children: "Total" }),
                    /* @__PURE__ */ jsx("span", { children: totalAmount })
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: 8 }, children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                flex: 1,
                padding: "8px 0",
                borderRadius: 8,
                background: accentBg,
                border: `1px solid ${accentColor}44`,
                textAlign: "center",
                fontSize: 12,
                fontWeight: 700,
                color: accentColor
              },
              children: primaryLabel
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                flex: 1,
                padding: "8px 0",
                borderRadius: 8,
                background: "var(--voice-widget-img-bg, #F9FAFB)",
                border: "1px solid var(--voice-widget-border, #E5E7EB)",
                textAlign: "center",
                fontSize: 12,
                fontWeight: 600,
                color: "var(--voice-widget-muted, #6B7280)"
              },
              children: secondaryLabel
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              textAlign: "center",
              fontSize: 11,
              color: "var(--voice-widget-muted, #6B7280)",
              marginTop: 8
            },
            children: "Say your choice aloud"
          }
        )
      ]
    }
  );
};
export {
  ConfirmWidget
};
//# sourceMappingURL=ConfirmWidget.js.map
